import {Field} from "react-final-form";
import {splitFieldProps} from "./splitFieldProps";
import AutocompletePrimitive from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import SearchIcon from "@material-ui/icons/Search";
import {useQuery} from "@tanstack/react-query";
import {useTranslation} from "react-i18next";

export function Autocomplete(props) {
    const {t} = useTranslation();
    return (
        <AutocompletePrimitive
            disablePortal
            sx={{backgroundColor: "#eeeeee"}}
            renderInput={(params) => (
                <TextField
                    {...params}
                    className="shadow-[0_1px_8px_rgba(0,0,0,0.15)]"
                    InputProps={{
                        ...params.InputProps,
                        sx: {
                            // borderRadius: "0 !important",
                            backgroundColor: "#fff",
                            "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                                // borderBottom: "1px solid #3D5166",
                                // borderRadius: 0,
                            },
                        },
                        startAdornment: <SearchIcon/>,
                    }}
                    placeholder={t("device.model")}
                />
            )}
            {...props}
        />
    );
}

export function AutocompleteField(props) {
    const [fieldProps, autocompleteProps] = splitFieldProps(props);

    return (
        <Field
            {...fieldProps}
            render={({input, meta}) => (
                <Autocomplete
                    {...autocompleteProps}
                    {...input}
                    onChange={(event, newValue) => {
                        input.onChange(newValue);
                        autocompleteProps.onChange?.(event, newValue);
                    }}
                />
            )}
        />
    );
}

export function AutocompleteQueryField({
                                           queryOptions = {enabled: false},
                                           ...props
                                       }) {
    const {data: options = [], isLoading} = useQuery(queryOptions);

    if (isLoading && queryOptions?.key) return null;

    return <AutocompleteField {...props} options={options}/>;
}
